import * as Directives from './';

Object.values(Directives).forEach((registerDirective) => {
  if (typeof registerDirective === 'function') registerDirective();
});

export default Directives;
